import { Icon, IconButton, TextField } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ModalActions from 'components/ModalActions';
import MyTable, { MyTableBody, MyTableCol, MyTableHeader, MyTablePagination, MyTableRow } from 'components/MyTable/';
import Spin from 'components/Spin';
import moment from 'moment';
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { infoMoneyTransferFile, listTransfers } from 'store/Orbita/Financial/actions';
import { ruleRunner, run } from 'validations/ruleRunner';
import { isEmail, required } from 'validations/rules';

import styles from '../styles';

import type IPagination from 'interfaces/IPagination';
import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

const fieldValidations = {
  email: ruleRunner('email', 'e-mail', required, isEmail),
};

interface IProps extends DispatchProp<any>, StyledComponentProps {
  filters?: any;
  list: any;
  isFetching: boolean;
  onClickRow?: any;
  currentUser: IUser;
  infoMoneyReportTransfersIsFetching: boolean;
  infoMoneyReportTransfers: any;
  loadingHistoryId: any;
  isButtonSecretEnabled: any;
}

interface IStates {
  pagination: IPagination;
  compositionDestination: string;
  compositionModal: boolean;
  compositionId: number;
  isEmailInvalid: boolean;
  emailErrorMsg: any;
}

const indexes = [
  { title: '', ordering: false },
  { title: 'Pedido', ordering: false },
  { title: 'Conta', ordering: false },
  { title: 'Envio', ordering: false },
  { title: 'Retorno', ordering: false },
  { title: 'Valor', ordering: false },
  { title: 'Resposta', ordering: false },
  { title: '', ordering: false },
];

class HistoryTable extends Component<IProps, IStates> {
  constructor(props: any) {
    super(props);

    this.state = {
      pagination: {
        per_page: 5,
        total_items: props.list && Array(props.list) ? props.list.length : 0,
        current_page: 0,
      },
      compositionDestination: '',
      compositionModal: false,
      compositionId: null,
      isEmailInvalid: true,
      emailErrorMsg: null,
    };
  }

  callMoreData = async () => {
    try {
      //this.props.dispatch(listTransfers(this.props.filters, pagination));
      await this.props.dispatch(listTransfers());
      let pagination = this.state.pagination;
      pagination.total_items = Array(this.props.list) ? this.props.list.length : 0;
      this.setState({ pagination });
    } catch (error) {}
  };

  componentDidMount() {
    this.callMoreData();
  }

  onChangePagination = (event: any, newPage: number) => {
    this.setState({ pagination: { ...this.state.pagination, current_page: newPage } });
  };

  changeCompositionDestination = (e: any) => {
    this.setState({ compositionDestination: e.target.value }, () => {
      const em = run({ email: this.state.compositionDestination }, [fieldValidations.email]);
      const isEmailInvalid = em['email'];
      this.setState({ isEmailInvalid, emailErrorMsg: em['email'] });
    });
  };

  openCompositionModal = (id: number) => {
    this.setState({ compositionId: id, compositionModal: true });
  };

  requestComposition = async () => {
    const { compositionId: transferId, compositionDestination: email } = this.state;

    try {
      await this.props.dispatch(infoMoneyTransferFile(transferId, email));

      toast.success(`Relatório será enviado para o email: ${email}`);
      this.setState({ compositionId: null, compositionModal: false, compositionDestination: '' });
    } catch (err) {
      toast.error('Erro ao solicitar composição de saque, verifique os dados ou tente novamente mais tarde.');
    }
  };

  render() {
    const spinner = <Spin />;

    const { classes, list: dataItems } = this.props;

    const pagination = this.state.pagination;
    return (
      <div className={classes.content}>
        {this.props.isFetching ? (
          spinner
        ) : (
          <MyTable>
            <MyTableHeader index={indexes} />
            <MyTableBody>
              {dataItems &&
                !dataItems.isFetching &&
                Array.isArray(dataItems) &&
                (pagination.per_page > 0
                  ? dataItems.slice(
                      pagination.current_page * pagination.per_page,
                      pagination.current_page * pagination.per_page + pagination.per_page
                    )
                  : dataItems
                ).map((item: any) => {
                  return (
                    <MyTableRow key={`item-${item.id}`}>
                      <MyTableCol status screenSizes={{ xs: 2, sm: 1 }}>
                        <Tooltip title={item.name} placement='top'>
                          <div className={`${this.props.classes.status} --${item.name}`} />
                        </Tooltip>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 6, sm: 1, md: 3, lg: 3 }} mobileOrder={2}>
                        <div>{item.created_at && moment(item.created_at).format('L')}</div>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 12, sm: 4, md: 3, lg: 3 }} mobileOrder={1}>
                        <div style={{ minHeight: 32, display: 'flex', alignItems: 'center' }}> {item.account_number}</div>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 6, sm: 1, md: 3, lg: 3 }} mobileOrder={2}>
                        <div>{item.date_batch && moment(item.date_batch).format('L')}</div>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 6, sm: 1, md: 3, lg: 3 }} mobileOrder={2}>
                        <div>{item.returned_at && moment(item.returned_at).format('L')}</div>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 3, sm: 0, md: 3, lg: 3 }} mobileOrder={6}>
                        <FormattedNumber value={item.amount} format={'BRL'} />
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 5, sm: 2, md: 6, lg: 3 }} mobileOrder={3}>
                        <div>{item.return}</div>
                      </MyTableCol>
                      {item.can_request_transfer_composition_report && item.name.toLowerCase() === 'confirmada' && (
                        <MyTableCol screenSizes={{ xs: 5, sm: 2, md: 6, lg: 3 }} mobileOrder={3}>
                          <IconButton onClick={() => this.openCompositionModal(item.id)} className={classes.button}>
                            <Icon>description</Icon>
                          </IconButton>
                        </MyTableCol>
                      )}
                      {(!item.can_request_transfer_composition_report || item.name.toLowerCase() !== 'confirmada') && (
                        <MyTableCol screenSizes={{ xs: 5, sm: 2, md: 6, lg: 3 }} mobileOrder={3} />
                      )}
                    </MyTableRow>
                  );
                })}
              {dataItems && dataItems.length === 0 && (
                <tr>
                  <td colSpan={9} style={{ textAlign: 'center', paddingTop: 20 }}>
                    Nenhum registro encontrado.
                  </td>
                </tr>
              )}
            </MyTableBody>
          </MyTable>
        )}

        {!this.props.isFetching && (
          <MyTablePagination
            onPageChange={this.onChangePagination}
            rowsPerPage={pagination?.per_page || 0}
            count={pagination?.total_items || 0}
            page={pagination?.current_page || 0}
            labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
            labelRowsPerPage='Itens por página:'
            rowsPerPageOptions={[5]}
          />
        )}

        <ModalActions
          buttonOkDisabled={this.state.isEmailInvalid}
          title={'Composição de Saque'}
          open={this.state.compositionModal}
          onClose={() => this.setState({ compositionId: null, compositionModal: false, compositionDestination: '' })}
          onOk={this.requestComposition}
        >
          <TextField
            placeholder='E-mail'
            type='email'
            value={this.state.compositionDestination}
            onChange={this.changeCompositionDestination}
            helperText={this.state.emailErrorMsg ? this.state.emailErrorMsg : 'E-mail que irá receber o relatório de composição de saque.'}
            error={this.state.isEmailInvalid}
          />
        </ModalActions>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    list: state.orbita.Financial.listTransfers.transfers,
    isFetching: state.orbita.Financial.listTransfers.isFetching,
    currentUser: state.orbita.User.user.user,
    infoMoneyReportTransfersIsFetching: state.orbita.Financial.infoMoneyReportTransfers.isFetching,
    infoMoneyReportTransfers: state.orbita.Financial.infoMoneyReportTransfers,
    loadingHistoryId: state.orbita.Financial.infoMoneyReportTransfers.id,
    isButtonSecretEnabled: state.components.Menu.enableSecretButton,
  };
}

export default styles(connect(mapStateToProps)(HistoryTable));
